module.exports = __webpack_public_path__ + "img/medium-invest.d780de74.svg";